




import {Component, Prop, Vue} from "vue-property-decorator";
import {PartnerStore} from "../../store";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {AuthStore} from "@/modules/auth/store";

@Component({
    name: "PartnerLabel"
})
export default class extends mixins(CommonMixin) {
    @Prop({ required: true, type: String })
    readonly id!: string;

    get label() {
        let label = `${PartnerStore.data[this.id]?.code} - ${PartnerStore.data[this.id]?.name}`;
        if (this.isAdmin) {
            label += ` - ${PartnerStore.data[this.id]?.postOffice?.name}`;
        }
        return label;
    }
}
